export default "__VITE_ASSET__BJIgRvGF__"